<template>
  <div>
    <CouponList v-if="list.lenght > 0" ref="CouponList" @getCouponList="getCouponList" :list="list" />
    <NoData v-else text="暂无优惠券可用" :empty="empty"  />
  </div>
</template>

<script>
import CouponList from '@/components/common/coupon/couponList'
export default {
  components:{
    CouponList,
  },
  data(){
    return {
      pageIndex:1,
      list:[],
      empty:require("@/assets/imgs/empty/noCoupon.png")
    }
  },
  created(){
    this.getCouponList()
  },
  methods:{
    getCouponList(){
      this.Api({
        url:"api/mine/getCouponList?pageIndex=" + this.pageIndex,
        method:"GET"
      }).then(res => {
        this.pageIndex += 1
        this.list = this.list.concat(res.data.data)
        this.$refs.CouponList.loading = false
        if(this.list.length + 1 >= res.data.total)
        this.$refs.CouponList.finished = true
      })
    }
  }
}
</script>

<style lang="less" scoped>

</style>